import {
  BILLING_VENDOR_ADD_CLEAN_REQUEST,
  BILLING_VENDOR_ADD_REQUEST,
  BILLING_VENDOR_ADD_REQUEST_FAILURE,
  BILLING_VENDOR_ADD_REQUEST_SUCCESS,
  BILLING_VENDOR_RESET_LOADING,
} from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const billingVendorAddReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case BILLING_VENDOR_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case BILLING_VENDOR_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
      });

    case BILLING_VENDOR_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case BILLING_VENDOR_RESET_LOADING:
      return Object.assign({}, state, {
        loading: false,
      });

    case BILLING_VENDOR_ADD_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default billingVendorAddReducer;
